import { QueueWaitOfferType } from '.';
import { VoiceMessageBuilder } from '../..';
import { userInputOptionBuilder } from '..';
var QueueWaitOfferOptionBuilder = /** @class */ (function () {
    function QueueWaitOfferOptionBuilder() {
        this.queueOffer = {
            queueWaitOfferType: QueueWaitOfferType.CALLBACK,
            offerMessage: new VoiceMessageBuilder().build(),
            userInputOption: userInputOptionBuilder({ messages: [new VoiceMessageBuilder().build()] })
        };
    }
    QueueWaitOfferOptionBuilder.prototype.withQueueWaitOfferType = function (queueWaitOfferType) {
        this.queueOffer.queueWaitOfferType = queueWaitOfferType;
        return this;
    };
    QueueWaitOfferOptionBuilder.prototype.withOfferMessage = function (offerMessage) {
        this.queueOffer.offerMessage = offerMessage;
        return this;
    };
    QueueWaitOfferOptionBuilder.prototype.withUserInputOption = function (userInputOption) {
        this.queueOffer.userInputOption = userInputOption;
        return this;
    };
    QueueWaitOfferOptionBuilder.prototype.build = function () {
        return this.queueOffer;
    };
    return QueueWaitOfferOptionBuilder;
}());
export { QueueWaitOfferOptionBuilder };
//# sourceMappingURL=queue-wait-offer-option.builder.js.map